import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { WhatsAppIcon, FadeUp } from "./Reveal";
import { useLang } from "../i18n/LanguageContext";
import { IMG, waLink } from "../data/site";

export default function ThermalFeature() {
  const { T } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section
      ref={ref}
      data-testid="thermal-park-feature"
      className="relative flex min-h-[70vh] items-center justify-center overflow-hidden py-16 md:py-32"
    >
      <motion.div style={{ y }} className="absolute inset-0 -top-16 -bottom-16">
        <img
          src={IMG.thermal}
          alt={T.thermal.title}
          loading="lazy"
          className="h-full w-full object-cover"
        />
      </motion.div>
      <div className="absolute inset-0 bg-[#2b1e1c]/72" />

      <div className="container-x relative z-10">
        <div className="mx-auto max-w-2xl text-center">
          <FadeUp>
            <p className="eyebrow !text-federasol-rose [text-shadow:0_1px_10px_rgba(0,0,0,0.55)] bg-[#2b1e1c]/35 inline-block px-4 py-1.5 rounded-full backdrop-blur-sm">
              {T.thermal.eyebrow}
            </p>
            <h2 className="mt-4 font-serif text-4xl font-medium leading-tight text-federasol-cream sm:text-5xl [text-shadow:0_2px_18px_rgba(0,0,0,0.35)]">
              {T.thermal.title}
            </h2>
            <p className="mt-5 text-base leading-relaxed text-federasol-cream/90 md:text-lg [text-shadow:0_1px_10px_rgba(0,0,0,0.4)]">
              {T.thermal.desc}
            </p>
            <div className="mt-9 flex flex-col items-center gap-4">
              <a
                href={waLink(T.wa.thermas)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="thermal-whatsapp-cta"
                className="btn-primary"
              >
                <WhatsAppIcon className="h-4 w-4" />
                {T.thermal.cta}
              </a>
              <p className="text-xs italic text-federasol-cream/90 [text-shadow:0_1px_8px_rgba(0,0,0,0.5)]">
                {T.thermal.note}
              </p>
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
